import styled from "styled-components";

export default styled.footer`
	display: flex;
	gap: 1.5rem;
	padding: 1rem var(--template-padding-sides);
	justify-content: flex-end;
`;